module.exports = __webpack_public_path__ + "static/ogp-93096dca8da99c0200dc38c476c97a4f.jpg";